export default function RequestingSOI() {
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button className="accordion-button caret-off collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseRequestingSOI">
          <i className="fa-solid fa-traffic-light fa-2xl feature-icon af-icon"></i>
          <b>Pennsylvania Ave & Trenton Ave Signal Improvements - PA DOT MTF Project<br/>Statments Of Intrest Requested for Consulting Engineering Services</b>
          <span className="badge bg-secondary badge-custom">Notice</span>
        </button>
      </h2>
      <div id="collapseRequestingSOI" className="accordion-collapse collapse" data-bs-parent="#latestNewsAccordion">
        <div className="accordion-body">

            
<p>
STATEMENTS OF INTEREST<br/>
CONSULTING ENGINEERING SERVICES<br/>
Pennsylvania Ave & Trenton Ave Signal Improvements<br/>
PennDOT Multimodal Transportation Fund (MTF) Project<br/>
</p>

 <p>
            <a href="../docs/notice/notice-2026-SOI-Consulting-Eng-Services-MTF-Grant-deadline-oct27.pdf" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-lg"></i>
              &nbsp;PA DOT MTF Grant Project - SOI for Consulting Engineering Services
            </a>
          </p>
<p>Morrisville Borough, Bucks County, Pennsylvania, is requesting Statements of Interest (SOIs) from PennDOT pre-certified engineering firms for professional consulting engineering services for the Pennsylvania Ave & Trenton Ave Signal Improvements Project, funded in part by the PennDOT Multimodal Transportation Fund (MTF).</p>

<p>The selection of the consulting engineer will be conducted in accordance with PennDOT Publication 93, Appendix 7A (Qualifications-Based Selection procedures). The scope of services may include, but is not limited to, preliminary engineering, final design, bidding assistance, and construction-related services, as authorized. The full scope of services and requirements for the SOI can be found on the Borough Website.</p>

<p>Only firms prequalified by the Pennsylvania Department of Transportation for the required work categories are eligible to submit Statements of Interest. Cost proposals shall not be submitted at this time.</p>

<p>The Project generally includes modernization of the traffic signals and associated equipment to improve traffic operations, pedestrian mobility, bicycle safety, and transportation efficiency.</p>

<p>
    <strong>
Statements of Interest must be received by:<br/>
October 27, 2026 at 11:00 AM (prevailing time)<br/>
</strong>
</p>

<p>
Submission (electronic PDF only) shall be sent to:<br/>
Virginia Cyphers, Assistant Borough Secretary<br/>
Morrisville Borough<br/>
Email: <a href="mailto:info@morrisvilleboro.org" className="no-underline"><i className="fa-solid fa-envelope"></i>&nbsp;info@morrisvilleboro.org</a>
</p>

<p>Participation by Disadvantaged Business Enterprises (DBEs) is encouraged in accordance with applicable federal and state requirements.</p>

<p>Morrisville Borough reserves the right to reject any or all Statements of Interest, to waive any informalities, and to modify or cancel this solicitation as permitted by law and PennDOT regulations.</p>

<p>
BY ORDER OF THE BOROUGH COUNCIL<br/>
MORRISVILLE BOROUGH
</p>


        </div>
      </div>
    </div>
  );
}